import Autocomplete from "bootstrap5-autocomplete";

$(function () {
    const input = document.getElementById('txt-search-branch');
    const branchItemsContainer = document.getElementById('branch-items-container');
    const btnClearSearch = document.getElementById('btn-clear-search');
    const iconClearSearch = document.getElementById('icon-clear-search');
    const iconSearch = document.getElementById('icon-search');
    if (!input || !branchItemsContainer || !btnClearSearch || !iconClearSearch || !iconSearch) {
        return;
    }
    if (input.value) {
        iconClearSearch.style.display = 'block';
        iconSearch.style.display = 'none';
    }
    const handleSearch = (value) => {
        if (value) {
            iconClearSearch.style.display = 'block';
            iconSearch.style.display = 'none';
            $(btnClearSearch).toggleClass('btn-outline-secondary', false);
            $(btnClearSearch).toggleClass('btn-secondary', true);
            btnClearSearch.disabled = false;
            Array.from(branchItemsContainer.children).forEach((child) => {
                const name = child.querySelector('.branch-item-name').textContent;
                const isIncluded = name.toLowerCase().includes(value.toLowerCase());
                if (!isIncluded) {
                    child.style.display = 'none';
                } else {
                    child.style.display = 'block';
                }
            });
        } else {
            iconClearSearch.style.display = 'none';
            iconSearch.style.display = 'block';
            $(btnClearSearch).toggleClass('btn-outline-secondary', true);
            $(btnClearSearch).toggleClass('btn-secondary', false);
            btnClearSearch.disabled = true;
            Array.from(branchItemsContainer.children).forEach((child) => {
                child.style.display = 'block';
            });
        }
    }
    new Autocomplete(input, {
        suggestionsThreshold: 0,
        fullWidth: true,
        fuzzy: true,
        onSelectItem: (element) => {
            handleSearch(element?.value);
        }
    });
    $(input).on('input', function (event) {
        handleSearch(event.target.value);
    });
    $(btnClearSearch).on('click', function () {
        input.value = '';
        handleSearch('');
        iconClearSearch.style.display = 'none';
        iconSearch.style.display = 'block';
    });
});
